<a *ngIf="path" class="d-block" (click)="goToPath(path)" [innerHTML]="innerHtml"></a>
<span *ngIf="action" class="d-block" (click)="actionClicked.emit()" [innerHTML]="innerHtml"></span>
<div *ngIf="icon">
    <kui-icon [name]="icon.name" [ngStyle]="{color: icon.color}" class="mr-2"></kui-icon>
    <span [innerHTML]="innerHtml"></span>
</div>
<span *ngIf="!path && !action && !icon" [innerHTML]="innerHtml"></span>
